import { Accordion } from '@mui/material';
import { Box, Stack, styled, Theme, Table } from '@/theme/index';

export const AdjustedTableHomeAddress = styled(Table)(({ theme }) => ({
  'td:first-of-type': {
    padding: `${theme.spacing(1)} ${theme.spacing(2)}`,
    width: '15px !important',
  },
}));

export const AdjustedTableMisconduct = styled(Table)(({ theme }) => ({
  'td:first-of-type': {
    padding: `${theme.spacing(1)} ${theme.spacing(2)}`,
    width: '150px !important',
  },
  td: {
    fontSize: '14px !important',
    [theme.breakpoints.up('sm')]: {
      fontSize: '16px !important',
    },
  },
}));

export const OffenderIndex = styled(Stack)(({ theme }) => ({
  borderRadius: '50%',
  width: '40px',
  height: '40px',
  backgroundColor: theme.palette.primary.main,
  color: theme.palette.primary.contrastText,
}));

export const dataListStyle = (theme: Theme) => ({
  '.MuiTable-root': {
    width: '100%',
  },
  td: {
    padding: `${theme.spacing(1)} ${theme.spacing(2)}`,
    width: '68px',
  },
  '.MuiTableRow-root:nth-of-type(odd)': {
    backgroundColor: theme.palette.background.default,
  },
  '.MuiTableRow-root:nth-of-type(even)': {
    backgroundColor: theme.palette.background.paper,
  },
});

export const MarkingsBox = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.background.default,
  padding: `${theme.spacing(1)} ${theme.spacing(2)}`,
}));

export const StyledAccordion = styled(Accordion)(() => ({
  boxShadow: 'none',
  bottom: 0,
  width: '100%',
}));
